import EditIcon from "@/assets/icons/EditIcon";
import { Heading, Paragraph } from "@/components/ui/Typography";
import { useState } from "react";
import { useMicroSiteContext } from "@/contexts/MicroSiteContext";
import TitleAndDescriptionForm from "@/pages/articles-pages/programmes/MultiStepForm/MicroSite/Templates/Shared/TitleAndDescriptionForm";
import { sanitizeHtml } from "@/utils/helpers/html";


const MissionOverview = () => {
  const { templatePayload:data, updateTemplatePayload } = useMicroSiteContext();

       const isEdit = new URLSearchParams(window.location.search).get('action') === 'edit';
  const [isEditing, setIsEditing] = useState(false);
    
      const handleSave = (formData: {title: string, description: string}) => {
        setIsEditing(false);
        const updatedPayload = {
          ...data,
          missionTimeLineSection: {
            ...data.missionTimeLineSection,
              missionTimeLineTitle: formData.title,
              missionTimeLineDescription: formData.description
          },
        };
        updateTemplatePayload(updatedPayload);
      };
  

  const PreviewComponent = () => {
    return (
      <div className="flex relative flex-col w-full p-4 lg:p-8 gap-2  justify-center" >   
          <div className="flex items-center gap-3">
          <Heading level={3}>{data.missionTimeLineSection.missionTimeLineTitle}</Heading>
{isEdit && <EditIcon  className="cursor-pointer" onClick={() => setIsEditing(true)} />}
          </div>
          <Paragraph dangerouslySetInnerHTML={{ __html: sanitizeHtml(data.missionTimeLineSection.missionTimeLineDescription ?? "") }} ></Paragraph>
      </div>
    )
  };

  return (
    <div>
      {isEditing ? <TitleAndDescriptionForm handleSave={handleSave} handleCancel={()=>setIsEditing(false)} data={{title: data.missionTimeLineSection.missionTimeLineTitle, description: data.missionTimeLineSection.missionTimeLineDescription}} /> : <PreviewComponent />}
    </div>
  )
}

export default MissionOverview